import FormGeneralError from 'components/formComponents/FormGeneralError';
import React, { useState } from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mainAccountHolders: any;
};

export const SubscriptionRenewalModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  mainAccountHolders,
}) => {
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Manage Subscription'}
      position="right"
      primaryBtnTxt="Close"
      givenClass="SubscriptionRenewalModal"
      primaryBtnColor="BtnGrey "
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => togglePanelOpen(false)}
      width={560}
      isSubmitting={isSubmitting}
    >
      {error && <FormGeneralError message={error} />}
      
      <p>If you would like to upgrade or cancel, ask one of your main account holders to take action. Your MAH are:</p>
      <div className="LineSpacer3"></div>
      <ul>
        {mainAccountHolders.map((item: any, index: number) => {
          return (<li key={"MAH_User_" + index}>{item.firstName + item.lastName}</li>);
        })}
      </ul>
    </PopupOrPanel>
  );
};
